import { ref } from 'vue'
import type { Ref } from 'vue'
import { addMessage } from '@/store/messages'
import { uid, uuid, isTypeFile } from '@/helpers'
import { KeysReplyContentType, MessageType, MessageChat } from '@/types/message'
import services from '@/services'
import useStore from '@/hooks/useStore'
import useMessage from '@/hooks/useMessage'

interface Chat {
  isFocusTextarea: Ref<boolean>
  setFocusTextarea: (value: boolean) => void

  handleUpload (payload: FormData, type: string): Promise<void>

  finishChat (): void

  startChat (): void

  handleAddMessage (value: string, type?: MessageType, messageType?: KeysReplyContentType): Promise<void>
}

const isFocusTextarea = ref<boolean>(false)

export default function useChat (): Chat {
  const store = useStore()
  const { isSelectMessageReply, clearIsMessage } = useMessage()

  function setFocusTextarea (value: boolean) {
    isFocusTextarea.value = value
  }

  async function handleAddMessage (message: string, type: MessageType = 'sent', messageType: KeysReplyContentType = 'text'): Promise<void> {
    const reply = isSelectMessageReply.value
    const data: MessageChat = {
      id: uid(),
      uuid: uuid().toString(),
      device: 'webchat',
      origin: 'webchat',
      type: type,
      api_key: store.apiKey,
      timestamp: new Date().getTime(),
      ack: 0,
      content: {
        message: message,
        type: messageType
      },
      status: 'pending'
    }

    if (reply) {
      data.reply = reply
      clearIsMessage()
    }

    addMessage(data)
    await services.webchat.formSendMessage(data)
  }

  async function handleUpload (payload: FormData, typeFile: string): Promise<void> {
    try {
      const response = await services.webchat.upload(payload)
      if (response?.errors) {
        console.error(response.errors)
        return
      }

      const message = response?.data || ''
      const type = isTypeFile(typeFile)

      await handleAddMessage(message, 'sent', type)
    } catch (error) {
      console.error(error)
    }
  }

  function startChat (): void {
    const message = 'Chat iniciado'
    const type = 'system'

    handleAddMessage(message, type, 'started').then(() => ({}))
  }

  function finishChat (): void {
    const message = 'Chat encerrado'
    const type = 'system'

    handleAddMessage(message, type, 'closed').then(() => ({}))
  }

  return {
    isFocusTextarea,
    setFocusTextarea,
    handleUpload,
    startChat,
    finishChat,
    handleAddMessage
  }
}
